/**
 * @generated SignedSource<<f7c7c848aca2a5389eea7446163f7eb1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountSettingsDeleteAccountMutation$variables = {
  password: string;
};
export type AccountSettingsDeleteAccountMutation$data = {
  readonly deleteAccount: {
    readonly ok: boolean;
  };
};
export type AccountSettingsDeleteAccountMutation = {
  response: AccountSettingsDeleteAccountMutation$data;
  variables: AccountSettingsDeleteAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      }
    ],
    "concreteType": "DeleteAccountPayload",
    "kind": "LinkedField",
    "name": "deleteAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSettingsDeleteAccountMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AccountSettingsDeleteAccountMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d780a0451b1609b8e984a7928e8b69e6",
    "id": null,
    "metadata": {},
    "name": "AccountSettingsDeleteAccountMutation",
    "operationKind": "mutation",
    "text": "mutation AccountSettingsDeleteAccountMutation(\n  $password: String!\n) {\n  deleteAccount(password: $password) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c71a2baae1392493f7eea7ff69c100e";

export default node;
